import { Component, OnInit } from '@angular/core';
import { replacePlantService } from '../../service/replace-planct-service';
import { NotificationService } from '@progress/kendo-angular-notification';
import { CommonService } from '../../../../common/service/common.service';


@Component({
  selector: 'app-replace-plant',
  standalone: false,
  templateUrl: './replace-plant.component.html',
  styleUrl: './replace-plant.component.scss'
})
export class ReplacePlantComponent {

  plantNameList: any[] = [];
  filterPlantNameList: any[] = [];
  selectedOldPlant: any;
  selectedNewPlant: any;

  constructor(
    private replacePlantService:replacePlantService,
    private notificationService: NotificationService,
    private commonService:CommonService) {
   
  }

  ngOnInit() {
    this.getPlantNames();
  }

  getPlantNames() {
    this.replacePlantService.plantNameList({}).subscribe({
      next: (response: any) => {
        this.plantNameList = response;
        this.filterPlantNameList = [...this.plantNameList];
      },
      error: (err: any) => {
        console.error(err);
      }
    })
  }

  replacePlantNames() {
    let payload = {
      "oldPlantName": this.selectedOldPlant.plantname,
      "newPlantName": this.selectedNewPlant.plantname,
    }
    this.replacePlantService.replacePlantName(this.selectedOldPlant.plantname, this.selectedNewPlant.plantname).subscribe({
      next: (response: any) => {

        if (payload.oldPlantName !== payload.newPlantName) {
          this.commonService.showNotificationMessage('Successfully replaced old plant name with new plant name', 'success', 'center', 200, true, 60, 600);
          this.selectedOldPlant = null;
          this.selectedNewPlant = null;
        }
        else {
          this.commonService.showNotificationMessage('Old plant and New Plant cannot be same', 'error');
        }

      },
      error: (err: any) => {
        console.error(err);
      }
    })
  }

  handleFilter(value: any) {
    this.filterPlantNameList = this.plantNameList.filter(
      (s: any) => {
        return s.plantname.toLowerCase().indexOf(value.toLowerCase()) !== -1
      }
    );

  }

  onValueChange(value:any,type:number)
  {
    (type==0)? this.selectedOldPlant=value :this.selectedNewPlant=value;
  }

  showSuccess() {
    this.commonService.showNotificationMessage('Successfully replaced old plant name with new plant name', 'success','center', 200 , true, 60, 600);
  }

  showError() {
    this.commonService.showNotificationMessage('Old plant and New Plant cannot be same', 'error');
  }
}
